import React, {Fragment} from 'react';
import ReservationListItem from '../ReservationListItem/ReservationListItem';

function ReservationList(props) {

    const reservations = props.reservations.map(reservation => {
        return <ReservationListItem
            key={reservation.id}
            id={reservation.id}
            guestName={reservation.guestName}
            startDate={reservation.startDate}
            endDate={reservation.endDate}
            reservationEdit={props.reservationEdit}
            deleteHandler={props.deleteHandler}
            isHotelDetails={props.isHotelDetails}
        />
    });
    const isValid = () => {
        let user = JSON.parse(localStorage.getItem('user'));
        console.log(user);
        return (user.role === "ROLE_ADMINISTRATOR");
    }

    return (
        <Fragment>
            {
                props.reservations.length === 0 ? '' :
                    <div className="row">
                        <div className="col">
                            <hr/>
                            <table className="table table-bordered table-striped">
                                <thead>
                                <tr>
                                    {isValid() ? <th>Guest name</th> : ""
                                    }
                                    <th>Reservation date</th>
                                    {props.isHotelDetails ? "" : <th></th>}
                                </tr>
                                </thead>
                                <tbody>
                                {reservations}
                                </tbody>
                            </table>
                        </div>
                    </div>
            }
        </Fragment>
    )
}

export default ReservationList;


// WEBPACK FOOTER //
// ./src/components/ReservationList/ReservationList.jsx